/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  startTelegramUserLogin(inboxId) {
    return axios.post(`${this.url}/${inboxId}/telegram_user/start_login`);
  }

  verifyTelegramUserLoginCode(inboxId, params) {
    return axios.post(
      `${this.url}/${inboxId}/telegram_user/verify_code`,
      params
    );
  }

  verifyTelegramUserLoginPassword(inboxId, params) {
    return axios.post(
      `${this.url}/${inboxId}/telegram_user/verify_password`,
      params
    );
  }

  logoutTelegramUserInbox(inboxId) {
    return axios.post(`${this.url}/${inboxId}/telegram_user/logout`);
  }

  getTelegramUserInboxStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/telegram_user/status`);
  }
}

export default new Inboxes();
